import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const styles = {
  wrapper: {
    margin: '0px',
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: 'red',
    '&:hover': {
      backgroundColor: 'yellow',
    },
  },
  buttonProgress: {
    color: '#4a4a4a',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  button: {
    position: 'relative',
    fontSize: '1em',
    fontWeight: '600',
    width: '100%',
    padding: '1em',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    outline: 'none',
    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
    '&:disabled': {
      boxShadow: 'none',
      cursor: 'auto',
    },
  },
  buttonPrimary: {
    backgroundColor: '#4a8bcc',
    color: '#ffffff',
    '&:disabled': {
      backgroundColor: '#a9c6e5',
    },
    '&:hover:enabled': {
      backgroundColor: '#4786c5',
    },
    '&:active': {
      backgroundColor: '#a9c6e5',
    },
  },
  buttonSecondary: {
    backgroundColor: '#ffffff',
    boxShadow: '1px 1px 10px 0px rgb(0 0 0 / 18%)',
    color: '#4a4a4a',
    '&:disabled': {
      color: '#888888',
    },
    '&:hover:enabled': {
    },
    '&:active': {
      backgroundColor: '#d4d4d4',
    },
    border: 'none',
  },
  buttonDark: {
    backgroundColor: '#4A4A4A',
    color: '#ffffff',
    '&:disabled': {
      backgroundColor: '#a5a5a5',
    },
  },
  buttonDanger: {
    backgroundColor: 'unset',
    color: 'rgb(205, 61, 100)',
    boxShadow: 'none',
    '&:disabled': {
      color: 'rgb(241, 144, 170)',
    },
  },
  nooverflow: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

class Button extends Component {
  render() {
    const {
      disabled, onClick, children, loading, classes, className, color, nooverflow,
    } = this.props;

    let classNames = clsx({
      [classes.button]: true,
      [classes.buttonPrimary]: color === 'primary',
      [classes.buttonSecondary]: color === 'secondary',
      [classes.buttonDark]: color === 'dark',
      [classes.buttonDanger]: color === 'danger',
      [classes.nooverflow]: nooverflow,
    });

    if (className) {
      classNames += ` ${className}`;
    }

    return (
      <button
          className={classNames}
          disabled={disabled || loading}
          onClick={onClick}
        >
        { loading && <CircularProgress size={24} className={classes.buttonProgress} /> }
        {children}
      </button>
    );
  }
}

Button.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  color: PropTypes.string,
  nooverflow: PropTypes.bool,
};

export default withStyles(styles)(Button);
